// src/components/ui/button.jsx
import React from "react";

/**
 * Minimal "design system" for buttons (driver frontend).
 * - Backward compatible: default variant = primary (emerald).
 * - Avoids passing unknown props (variant/size) to DOM (React warnings).
 */
export function Button({
  children,
  onClick,
  className = "",
  type = "button",
  variant = "primary", // primary | secondary | destructive | outline | ghost
  size = "md", // sm | md | lg
  ...props
}) {
  const base =
    "inline-flex items-center justify-center rounded-xl " +
    "font-semibold text-sm md:text-base " +
    "transition-all duration-200 " +
    "shadow-md hover:shadow-lg " +
    "disabled:opacity-60 disabled:cursor-not-allowed " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 " +
    "focus:ring-yellow-400 focus:ring-offset-slate-900";

  const variants = {
    primary: "bg-emerald-500 hover:bg-emerald-600 text-white",
    secondary: "bg-slate-800 hover:bg-slate-700 text-white",
    destructive: "bg-red-600 hover:bg-red-700 text-white",
    outline: "bg-transparent border border-slate-700 hover:bg-slate-900 text-white",
    ghost: "bg-transparent hover:bg-slate-900 text-white",
  };

  const sizes = {
    sm: "px-3 py-1.5",
    md: "px-4 py-2",
    lg: "px-5 py-3 text-base",
  };

  const v = variants[variant] || variants.primary;
  const s = sizes[size] || sizes.md;

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${base} ${s} ${v} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
